import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import Drawer from "@material-ui/core/Drawer"
import ExpandLess from "@material-ui/icons/ExpandLess"
import ExpandMore from "@material-ui/icons/ExpandMore"
import List from "@material-ui/core/List"
import Divider from "@material-ui/core/Divider"
import IconButton from "@material-ui/core/IconButton"
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"
import ListItem from "@material-ui/core/ListItem"
import ListItemText from "@material-ui/core/ListItemText"
import { Typography, Hidden } from "@material-ui/core"
import Collapse from "@material-ui/core/Collapse"
import Footer from "./Footer"

const drawerWidth = 300

const useStyles = makeStyles(theme => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: "0 8px",
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
    background: "transparent",
    color: "#FFFFFF",
  },
  avatar: {
    marginRight: theme.spacing(1),
  },
  appSelection: {
    margin: "0px 20px 10px 20px",
    display: "flex",
    flexDirection: "column",
  },
  nested: {
    paddingLeft: theme.spacing(4),
    backgroundColor: "#0071e3",
    color: "#FFFFFF",
    "&:hover, &.Mui-selected": { color: "#0071e3" },
  },
}))

const LeftNav = ({ handleHideLeftNav, showLeftNav, route, user }) => {
  const classes = useStyles()
  const theme = useTheme()
  const [isOpenClickAndCollect, setIsOpenClickAndCollect] = useState(false)
  const [isOpenOrder, setIsOpenOrder] = useState(false)

  const history = useNavigate()
  const handleDrawerClose = () => handleHideLeftNav()

  const openClickAndCollect = () => {
    setIsOpenClickAndCollect(!isOpenClickAndCollect)
  }

  const openOrder = () => {
    setIsOpenOrder(!isOpenOrder)
  }


  const menuItems = [
    { label: "Dashboard", url: "/" },
    { label: "Customers", url: "/search-customer" },
    { label: "Tickets", url: "/all-tickets" },
  ]

  return (
    <>
      <Drawer
        className={classes.drawer}
        variant="temporary"
        open={showLeftNav}
        onClose={handleDrawerClose}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <Typography variant="h6" style={{ marginRight: 20, color: '#622aff', fontFamily: "'Hind Siliguri', sans-serif", fontSize: 30 }}>
            LiveDesk
          </Typography>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon style={{ color: "#622aff" }} />
            ) : (
              <ChevronRightIcon style={{ color: "#622aff" }} />
            )}
          </IconButton>
        </div>
        <Divider />
        <List>
          {menuItems.map((menuItem, i) => (
            <span key={i}>
              {menuItem.children ? (
                <>
                  <ListItem button onClick={menuItem.handler}>
                    <ListItemText primary={
                      <Typography variant="h6">
                        {menuItem.label}
                      </Typography>
                    } />
                    {menuItem.open ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={menuItem.open} timeout="auto">
                    {menuItem.children.map((child, indx) => (
                      <List component="div" disablePadding key={indx}>
                        <ListItem
                          selected={history.location.pathname.includes(child.url)}
                          className={classes.nested}
                          button
                          onClick={() => {
                            window.open(child.url, "_self")
                            handleHideLeftNav()
                          }}
                        >
                          <ListItemText primary={child.label} />
                        </ListItem>
                      </List>
                    ))}
                  </Collapse>
                </>
              ) : (
                <ListItem
                  button
                  onClick={() => {
                    window.open(menuItem.url, "_self")
                    handleHideLeftNav()
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography variant="h6">
                        {menuItem.label}
                      </Typography>
                    } />
                </ListItem>
              )}
            </span>
          ))}
        </List>
        <Hidden smUp>
          <Footer />
        </Hidden>
      </Drawer>
    </>
  )
}
export default LeftNav
